import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=287f4db0&scoped=true&"
import script from "./TestReport.vue?vue&type=script&lang=js&"
export * from "./TestReport.vue?vue&type=script&lang=js&"
import style0 from "./TestReport.vue?vue&type=style&index=0&id=287f4db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f4db0",
  null
  
)

export default component.exports